var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 7.69131C0.813401 7.69131 0.5 7.39411 0.5 7.02749V5.03606C0.5 4.66945 0.813401 4.37225 1.2 4.37225H20.8C21.1866 4.37225 21.5 4.66945 21.5 5.03606V7.02749C21.5 7.39411 21.1866 7.69131 20.8 7.69131H1.2Z",
    fill: "#FF4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.955 2.73483C13.6732 2.48382 13.6594 2.06372 13.9241 1.79652L15.4963 0.209319C15.761 -0.0578867 16.204 -0.0710154 16.4858 0.179995L21.0776 4.27044C21.3593 4.52145 21.3732 4.94155 21.1085 5.20875L19.5362 6.79595C19.2715 7.06316 18.8285 7.07629 18.5467 6.82528L13.955 2.73483Z",
    fill: "#FF4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5231 5.15087C18.8049 4.89986 19.2479 4.91299 19.5126 5.18019L21.1085 6.79124C21.3732 7.05844 21.3593 7.47854 21.0776 7.72955L16.4858 11.82C16.204 12.071 15.761 12.0579 15.4963 11.7907L13.9004 10.1796C13.6357 9.91243 13.6496 9.49233 13.9313 9.24132L18.5231 5.15087Z",
    fill: "#FF4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRed);
export default __webpack_public_path__ + "static/media/iconArrowRed.904710356dfbe40a8f6997ead8932c95.svg";
export { ForwardRef as ReactComponent };